import React from "react";
import {ConfirmModal, useNotifications} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {DayReport} from "@/data/entities/dayReport";
import {SetStateFn} from "@/utils/SetStateUtils";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {globalConfirmModalProps} from "@/utils/ModalUtils";
import {formatDate} from "@/utils/DateUtils";
import {exportDayReportCsv} from "@widgets/reports/dayReport/export/exportDayReportCsv";
import {reportDay} from "@widgets/reports/dayReport/DayReportUtils";

type Props = {
    dayReport: DayReport | undefined,
    show: boolean,
    setShow: SetStateFn<boolean>,
};

/**
 * Confirms the CSV export of the day report, like the timesheet export.
 */
const ExportDayReportModal = ({dayReport, show, setShow}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const {dashboardLocation} = useRestaurant();

    const exportCsv = () => {
        if (dayReport === undefined) return;

        exportDayReportCsv(dayReport, dashboardLocation);
        setShow(false);
        notify({message: intl.formatMessage({id: "downloadStartsImmediately"})});
    };

    return (
        <ConfirmModal
            {...globalConfirmModalProps(intl)}
            show={show}
            onClose={() => setShow(false)}
            title={intl.formatMessage({id: "dayReport.exportCsv"})}
            type={"info"}
            continueButton={{
                text: intl.formatMessage({id: "continue"}),
                onClick: exportCsv,
            }}
            disabled={dayReport === undefined}
        >
            {
                dayReport !== undefined &&
                <FormattedMessage
                    id={"dayReport.exportCsv.description"}
                    values={{
                        location: <strong className={"font-bold"}>{dashboardLocation.name}</strong>,
                        day: <strong className={"font-bold"}>{formatDate(reportDay(dayReport))}</strong>,
                    }}
                />
            }
        </ConfirmModal>
    );
};

export default ExportDayReportModal;